module.exports = require("./ar-SA.js");